import React from "react";
import ReactDOM from "react-dom";
import "./index.css";

interface CustomPopupProps {
  icon?: string;
  alt?: string;
  title: string;
  message: string;
  onClose: () => void;
  onConfirm?: () => void;
  confirmText?: string;
  cancelText?: string;
  type?: "error" | "confirm" | "warning";
  isLoading?: boolean;
}

const CustomPopup: React.FC<CustomPopupProps> = ({
  icon,
  alt = "icon",
  title,
  message,
  onClose,
  onConfirm,
  confirmText = "Aceptar",
  cancelText = "Cancelar",
  type = "error",
  isLoading = false,
}) => {
  return ReactDOM.createPortal(
    <div className={`custom-popup-overlay custom-popup-${type}`}>
      <div className="custom-popup">
        {icon && <img src={icon} alt={alt} className="custom-popup-icon" />}
        <h1 className="custom-popup-title">{title}</h1>
        <p className="custom-popup-message">{message}</p>
        <div className="custom-popup-button-wrapper">
          {onConfirm ? (
            <>
              <button className="custom-popup-button cancel" onClick={onClose} disabled={isLoading}>
                {cancelText}
              </button>
              <button className="custom-popup-button confirm" onClick={onConfirm} disabled={isLoading}>
                {isLoading ? (
                  <img src={require("assets/LoadingIcon.gif")} alt="Cargando..." className="popup-loader" />
                ) : (
                  confirmText
                )}
              </button>
            </>
          ) : (
            <button className="custom-popup-button" onClick={onClose} disabled={isLoading}>
              {confirmText}
            </button>
          )}
        </div>
      </div>
    </div>,
    document.body
  );
};

export default CustomPopup;
